import component from './buy.component';
import routes from './buy.routes';
import invalidComponent from './invalid/invalid.component';
import validComponent from './valid/valid.component';

export default angular
  .module('fizyweb.paycell.noauth.buy', [])
  .component('fizyPaycellNoAuthBuy', component)
  .component('fizyPaycellNoAuthBuyInvalid', invalidComponent)
  .component('fizyPaycellNoAuthBuyValid', validComponent)
  .config(routes).name;


// WEBPACK FOOTER //
// src/app/no-auth/buy/buy.module.ts